export default __webpack_public_path__ + "static/media/oneOfOneLoading.e6fba550.gif";